import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'

// Khởi tạo Email Service
// DISABLED: EmailJS đã hết quota free - tạm thời vô hiệu hóa
// import { emailServiceWithEmailJS } from './services/email/EmailServiceWithEmailJS'
// import { emailJSConfig, isEmailJSConfigured } from './config/emailjs.config'

// Khởi tạo EmailJS nếu đã cấu hình
// DISABLED: EmailJS đã hết quota free
console.log('📧 EmailJS: Tạm thời vô hiệu hóa (hết quota free)')
console.log('💡 Các tính năng khác vẫn hoạt động bình thường')
// if (isEmailJSConfigured()) {
//   emailServiceWithEmailJS.initialize(emailJSConfig)
//   console.log('✅ EmailJS đã được khởi tạo - Email THẬT sẽ được gửi!')
//   console.log('📧 Admin Email: quants82@gmail.com')
// } else {
//   console.warn('⚠️ EmailJS chưa được cấu hình')
//   console.warn('📝 Email sẽ là SIMULATION (chỉ hiển thị trong console)')
//   console.warn('💡 Để gửi email thật, điền thông tin vào: src/config/emailjs.config.ts')
//   console.warn('📖 Xem hướng dẫn: SETUP_REAL_EMAIL_STEP_BY_STEP.md')
// }

// Khởi tạo QuizBankService để auto-scan trắc nghiệm ngay khi app load
// console.log('🚀 Initializing QuizBankService for auto-scan...')
// import('./services/quiz/QuizBankService').then(({ quizBankService }) => {
//   console.log('✅ QuizBankService loaded - auto-scan started in background')
//   // Service sẽ tự động scan trong constructor
// }).catch(error => {
//   console.error('❌ Failed to load QuizBankService:', error)
// })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
